import { fetch } from '@financial-tool/fetch';
import { TaxFolderConnect } from '../types/settings';

export default function getInvoicesFromTaxFolder(data: TaxFolderConnect) {
  return fetch.post('/invoicing/sync', data, {}, false);
}
